import { UserModel, userModelInitial } from './UserModel';

export interface LoginModel {
    user: UserModel,
    token: string
}

export const loginModelInitial = {
    user: userModelInitial,
    token: ''
};